import { render } from "./MatrixBoard.vue?vue&type=template&id=7eebc67e&scoped=true"
import script from "./MatrixBoard.vue?vue&type=script&lang=js"
export * from "./MatrixBoard.vue?vue&type=script&lang=js"

import "./MatrixBoard.vue?vue&type=style&index=0&id=7eebc67e&lang=scss&scoped=true"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7eebc67e"]])

export default __exports__